import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { Linear, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import { MathUtils, PointUtils } from "html-living-framework";
import { floatBetween } from "html-living-framework/lib/Utils/Random";
import { random } from "html-living-framework/lib/Utils/ArrayUtils";

export class Sheep extends SceneSpine {

	tracks = {
		BODY: 0,
	}

	protected _isBusy: boolean = false;
	protected _didMove: boolean = false;

	protected idleTimeline?: TimelineMax;

	constructor(pSkin: string) {
		super("sheep");
		// this.spine.state.setEmptyAnimation(this.tracks.BODY, 0);
		this.spine.skeleton.setSkinByName(pSkin);
		const entry = this.playAnimation('idle-no-ear-flick', false, this.tracks.BODY);
		this.update(floatBetween(0, entry!.animationEnd));
		this.idleTimeline = new TimelineMax();
		this.idleTimeline.call(()=>{
			if (!this._isBusy) {
				this.Idle();
			}
			this.idleTimeline!.delay(floatBetween(5, 10));
			this.idleTimeline!.restart(true);
		});
		this.idleTimeline!.delay(floatBetween(5, 10));
	}

	public get isBusy() { return this._isBusy; }
	public get didMove() { return this._didMove; }

	public onLayout() {
		super.onLayout();
		// this.scale.set(0.2);
	}

	public destroy() {
		super.destroy();
		this.idleTimeline?.kill();
	}

	public Eat(pCallback?: ()=>void) {
		this._isBusy = true;
		this.idleTimeline?.pause();
		const entry = this.playAnimation('eating', false, this.tracks.BODY);
		TweenLite.delayedCall(2.75, ()=>{
			this._isBusy = false;
			this.idleTimeline?.restart(true);
			pCallback?.();
		});
	}

	public WalkTo(pData: {x: number, y: number}, pCallback: ()=>void) {
		const speed = 100; // pixels per second
		const distance = PointUtils.distance(this.position, new PIXI.Point(pData.x, pData.y)); // pixels
		this.idleTimeline?.pause();
		this._isBusy = true;
		this.Walk();
		this._didMove = true;
		new TimelineLite()
			.to(this, distance / speed, {pixi: {
				x: pData.x,
				y: pData.y,
			}, ease: Linear.easeNone})
			.call(()=>{
				this.StopWalking();
				this._isBusy = false;
				this.Idle();
				this.idleTimeline?.restart(true);
				pCallback();
			});
	}

	protected Idle() {
		this.playAnimation(random(["idle-no-ear-flick", "idle"]), false, this.tracks.BODY);
	}

	protected Walk() {
		this.playAnimation("walk", true, this.tracks.BODY);
	}

	protected StopWalking() {
		// const entry = this.playAnimation("walk", false, this.tracks.BODY);
		// entry!.timeScale = 0;
		this.spine.state.setEmptyAnimation(this.tracks.BODY, 0);
	}
}